import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'hilti-spinner',
  templateUrl: './hilti-spinner.component.html',
  styleUrls: ['./hilti-spinner.component.scss']
})
export class HiltiSpinnerComponent implements OnInit {

  @Input() message = '';

  constructor() { }

  ngOnInit() {
  }

}
